/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useRoute, hasEntryParam } from 'src/hooks/use-route';

const INVALID_REDIRECT_PATHS = ['/', '/login'] as const;
const LINK_TYPE_INTERNAL = 'linkType=INTERNAL_LINK';
const DOWNLOAD_PATH = '/download';

const isInvalidRedirectPath = (path: string | null): boolean =>
  path != null && (INVALID_REDIRECT_PATHS as readonly string[]).includes(path);

/**
 * 리다이렉트 경로 처리 훅
 *
 * - redirectPath가 비허용 경로면 쿼리에서 제거
 * - 푸시/외부 링크(linkType=INTERNAL_LINK)로 진입했는데 entry가 없으면 entry=deeplink 부여(목록으로 가기·뒤로가기 동작용)
 *
 * @param isReady - 초기화 완료 여부 (선택적)
 */
export default function useRedirectPath(isReady?: boolean) {
  const location = useLocation();
  const route = useRoute();

  useEffect(() => {
    if (isReady === false) return;

    const queryParams = new URLSearchParams(location.search);
    const redirectPath = queryParams.get('redirectPath');
    let changed = false;

    if (isInvalidRedirectPath(redirectPath)) {
      queryParams.delete('redirectPath');
      changed = true;
    }

    const isDownloadPath = location.pathname.endsWith(DOWNLOAD_PATH);

    // 푸시 링크 등으로 linkType=INTERNAL_LINK만 있고 entry가 없으면 entry=deeplink 부여
    if (
      !isDownloadPath &&
      location.search.includes(LINK_TYPE_INTERNAL) &&
      !hasEntryParam(location.search)
    ) {
      queryParams.set('entry', 'deeplink');
      changed = true;
    }

    if (changed) {
      const newSearch = queryParams.toString();
      route.pushNavigate(location.pathname, newSearch, { replace: true });
    }
  }, [location.search, location.pathname, isReady, route]);
}
